import React, { FC } from 'react';
import { Form } from 'react-bulma-components';
import Placeholder from './Placeholder';
import * as styles from './PlaceholderTextField.module.scss';

interface PlaceholderTextFieldProps {
  caption?: number;
  label: number;
}

const PlaceholderTextField: FC<PlaceholderTextFieldProps> = ({ caption, label }) => {
  return (
    <Form.Field>
      <Form.Label>
        <Placeholder size={label} />
      </Form.Label>
      <Placeholder className={styles.input} />
      {caption && (
        <Form.Help>
          <Placeholder size={caption} />
        </Form.Help>
      )}
    </Form.Field>
  );
};

export default PlaceholderTextField;
